import { Component, Input, OnInit } from '@angular/core';
import { BreakpointState, ResizeService } from '@services/resize.service';
import { Observable } from 'rxjs';
import { SiqCommonModule } from '@shared/siq-common.module';
import { AppStoreBtnsComponent } from '@shared/standalone-components/app-store-btns/app-store-btns.component';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  standalone: true,
  imports: [SiqCommonModule, AppStoreBtnsComponent]
})
export class NoDataComponent implements OnInit {

  @Input() noDataIcon: string;
  @Input() noDataText: string;
  @Input() noDataSubtext: string;
  @Input() showAppDownload: boolean;
  @Input() hasMultipleRows: boolean;
  @Input() subtextWidth: string;
  @Input() sourceScreen: string;

  breakpoints$: Observable<BreakpointState>;

  constructor(private resizeService: ResizeService) {}

  get noDataIconClasses(): string {
    return `${this.noDataIcon} mt-32`;
  }

  get noDataSubtextClasses(): string {
    return `${this.subtextWidth} siq-text-400 fs-16 white text-center mt-16 px-24`;
  }

  ngOnInit(): void {
    this.breakpoints$ = this.resizeService.isMobile;
  }
}
